var render = function render(){var _vm=this,_c=_vm._self._c;return _c('attended-interview-listing',{attrs:{"is-admin":true}})
}
var staticRenderFns = []

export { render, staticRenderFns }